<template>
  <div class="hotel-category-component flex space-x-2">
    <img src="/img/icons/star.svg" v-for="star in stars" :key="star" />
  </div>
</template>

<script>
export default {
  props: {
    categoryCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    stars() {
      return Number(this.categoryCode.replace(/(LUX)|(EST)/, ''));
    }
  },
}
</script>

<style scoped>
img {
  width: 17px;
}
</style>
